module.exports = __webpack_public_path__ + "static/media/hollowcircleconcretesection.1c78695e.svg";